import { Box } from '@mui/material';

export const INV = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
